import { useFeature } from "@kiwicom/darwin"
import type { NavElement } from "@kiwicom/nitro/lib/components/TopNav"

const useNavbarHiddenElements = (): NavElement[] => {
  const isFareLockEnabled = useFeature("NAVBAR_FARE_LOCK")
  const isReferAFriendDisabled = useFeature("DISABLE_REFER_A_FRIEND")

  const hiddenElements: NavElement[] = []

  if (!isFareLockEnabled) {
    hiddenElements.push("fareLocks")
  }

  if (isReferAFriendDisabled) {
    hiddenElements.push("referAFriend")
  }

  return hiddenElements
}

export default useNavbarHiddenElements
